// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","submit":"styles_submit__mN-9N","form":"styles_form__fKP6Q"};